import { css } from 'styled-components';
import { mq } from '~/styles/grid';
import getFontFamily from '~/helpers/getFontFamily';

export const HeadlineBasic = css`
  color: ${(props) => props.theme.color.basicHeadlineColor};
`;

export const Headline800Skin = css`
  ${HeadlineBasic};
  font-family: ${(props) => getFontFamily(props.theme.headline.h800.xl.font)};
  font-size: ${(props) => props.theme.headline.h800.xl.fontSize};
  line-height: ${(props) => props.theme.headline.h800.xl.lineHeight};

  @media (${mq.xs}) {
    font-family: ${(props) => getFontFamily(props.theme.headline.h800.xs.font)};
    font-size: ${(props) => props.theme.headline.h800.xs.fontSize};
    line-height: ${(props) => props.theme.headline.h800.xs.lineHeight};
  }
`;

export const Headline700Skin = css`
  ${HeadlineBasic};
  font-family: ${(props) => getFontFamily(props.theme.headline.h700.xl.font)};
  font-size: ${(props) => props.theme.headline.h700.xl.fontSize};
  line-height: ${(props) => props.theme.headline.h700.xl.lineHeight};

  @media (${mq.xs}) {
    font-family: ${(props) => getFontFamily(props.theme.headline.h700.xs.font)};
    font-size: ${(props) => props.theme.headline.h700.xs.fontSize};
    line-height: ${(props) => props.theme.headline.h700.xs.lineHeight};
  }
`;

export const Headline600Skin = css`
  ${HeadlineBasic};
  font-family: ${(props) => getFontFamily(props.theme.headline.h600.xl.font)};
  font-size: ${(props) => props.theme.headline.h600.xl.fontSize};
  line-height: ${(props) => props.theme.headline.h600.xl.lineHeight};

  @media (${mq.xs}) {
    font-family: ${(props) => getFontFamily(props.theme.headline.h600.xs.font)};
    font-size: ${(props) => props.theme.headline.h600.xs.fontSize};
    line-height: ${(props) => props.theme.headline.h600.xs.lineHeight};
  }
`;

export const Headline500Skin = css`
  ${HeadlineBasic};
  font-family: ${(props) => getFontFamily(props.theme.headline.h500.xl.font)};
  font-size: ${(props) => props.theme.headline.h500.xl.fontSize};
  line-height: ${(props) => props.theme.headline.h500.xl.lineHeight};

  @media (${mq.xs}) {
    font-family: ${(props) => getFontFamily(props.theme.headline.h500.xs.font)};
    font-size: ${(props) => props.theme.headline.h500.xs.fontSize};
    line-height: ${(props) => props.theme.headline.h500.xs.lineHeight};
  }
`;

export const Headline400Skin = css`
  ${HeadlineBasic};
  font-family: ${(props) => getFontFamily(props.theme.headline.h400.xl.font)};
  font-size: ${(props) => props.theme.headline.h400.xl.fontSize};
  line-height: ${(props) => props.theme.headline.h400.xl.lineHeight};

  @media (${mq.xs}) {
    font-family: ${(props) => getFontFamily(props.theme.headline.h400.xs.font)};
    font-size: ${(props) => props.theme.headline.h400.xs.fontSize};
    line-height: ${(props) => props.theme.headline.h400.xs.lineHeight};
  }
`;
